<template>
    <div class="modal-box">
        <div class="modal-box-inner" v-loading="loading">
            <div class="modal-box-header" v-if="this.header">
                <span class="modal-box-header-title">
                    share
                </span>
                <a class="modal-box-header-back" @click.prevent="close()">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14"><defs><clipPath id="clip-path"><rect width="14" height="14" fill="none"/></clipPath></defs><g id="Icon_-_Close" data-name="Icon - Close" clip-path="url(#clip-path)"><path id="ic_close_24px" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)" fill="#444"/></g></svg>
                </a>
            </div>
            <span class="modal-box-header-inner mobile-hide">
                share
            </span>

            <div class="modal-box-content asset-share">
                <div class="asset-share-link">
                    <a v-if="!link" herf="#" @click.prevent="getLink($event)" class="get inactive">
                        get shareable link
                    </a>
                    <div v-else>
                        <a herf="#" @click.prevent="" class="get active">
                            anyone with an account can view
                        </a>
                        <textarea :value="link" id="link" readonly></textarea>
                        <a herf="#" @click.prevent="copyText" class="underlined">copy link</a>
                    </div>
                </div>

                <div class="asset-share-autocomplete">
                    <input type="text"
                           class="asset-share-autocomplete-link-input"
                           placeholder="user email"
                           v-model="userEmail"
                           @focus="showList = true"
                           @keyup="debounce($event.target.value, 400, $event.keyCode)"
                    >
                    <div class="asset-share-autocomplete-selection" :class="{'visible': showList}" v-if="!showListItems">
                        <span v-for="user in autocompleteUsers" :key="user.id" @click="addUser(user)" class="asset-share-autocomplete-users" :class="{'added': users.findIndex(function (item) { return item.id === user.id }) !== -1}">{{ user.email }}</span>
                    </div>
                </div>

                <div class="asset-share-autocomplete-selected">
                    <p v-for="user in users" :key="user.id">{{user.first_name + ' ' + user.last_name}} <button @click="removeUser(user)"></button></p>
                </div>

                <div class="modal-box-action">
                    <button  @click.prevent="getLink($event, true)" type="primary" class="modal-box-action-item button">Share</button>

                    <button @click.prevent="close" type="text" class="modal-box-action-item link">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'AssetShareModal',
  data () {
    return {
      loading: false,
      userEmail: '',
      users: [],
      autocompleteUsers: [],
      showList: false,
      showListItems: false,
      link: null,
      timeoutId: null
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    getLink (event, email = false) {
      let preparedData = {
        assets: this.data.ids
      }

      if (email) {
        preparedData.email = true
        preparedData.users = this.users.map(function (user) { return user.id })

        if (preparedData.users.length === 0 && this.userEmail) {
          this.$notify({
            message: 'User not found',
            type: 'success',
            position: 'bottom-right',
            duration: 1750
          })
          return
        }
      } else {
        preparedData.email = false
      }

      this.loading = true
      HTTP({
        method: 'POST',
        url: '/api/v1/linkshare',
        crossdomain: true,
        data: preparedData
      })
        .then(response => {
          if (email) {
            this.$notify({
              message: 'Shared to selected users',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
            this.close()
          }

          if (response.data.data) {
            this.link = process.env.VUE_APP_BASE_URL + '/share/' + response.data.data.hash
          }

          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$notify({
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    copyText () {
      let el = document.getElementById('link')
      el.select()
      el.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    addUser (user) {
      if (this.users.findIndex(function (item) { return item.id === user.id }) === -1) {
        this.users.push(user)
      } else {
        this.removeUser(user)
      }
      this.showList = false
      this.userEmail = ''
      this.showListItems = true
      HTTP({
        method: 'GET',
        url: '/api/v1/users',
        crossdomain: true,
        params: {
          email: false
        }
      }).then(response => {
        if (response.data.data) {
          this.autocompleteUsers = response.data.data
          this.showList = true
          this.showListItems = false
        }
      }).catch(() => {
        this.autocompleteUsers = []
      })
    },
    removeUser (user) {
      let index = this.users.findIndex(function (item) { return item.id === user.id })
      if (index !== -1) {
        this.users.splice(index, 1)
      }
    },
    debounce (search, debounceDuration = 300, key = null) {
      let scope = this
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId)
      }
      this.timeoutId = setTimeout(_ => {
        scope.setKeywordSearch(search)
      }, debounceDuration)
    },
    setKeywordSearch (keyword) {
      this.autocompleteUsers = []
      HTTP({
        method: 'GET',
        url: '/api/v1/users',
        crossdomain: true,
        params: {
          email: keyword
        }
      }).then(response => {
        if (response.data.data) {
          this.autocompleteUsers = response.data.data
          this.showList = true
        }
      }).catch(() => {
        this.autocompleteUsers = []
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
